import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RawMaterialActionsEnum } from 'src/app/shared/enums/raw-material-actions.enum';

@Component({
    selector: 'app-modal-select-raw-material-action',
    template: `
        <div class="flex flex-col items-center p-6">
            <div class="flex justify-center gap-4">
                <button (click)="selectOrigin(RawMaterialActionsEnum.CHANGE_ARTICLE)"
                    class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6">
                    Cambiar artículo
                </button>
               <!--  <button (click)="selectOrigin(RawMaterialActionsEnum.DELETE)"
                    class="text-white bg-green-500 hover:bg-green-600 focus:ring-4 focus:ring-green-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-green-600 dark:hover:bg-green-700 focus:outline-none dark:focus:ring-green-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6">
                    Eliminar
                </button> -->
            </div>
        </div>
    `
})

export class ModalSelectRawMaterialActionComponent {
    @Output() originSelected = new EventEmitter<RawMaterialActionsEnum>();

    RawMaterialActionsEnum = RawMaterialActionsEnum;

    selectOrigin(origin: RawMaterialActionsEnum) {
        this.originSelected.emit(origin);
    }
}
